import { AddressDetails } from "../smart-components/smart-component-property";
import { SmartComponentPropertyDetails } from "../smart-components/smart-component-property-details";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { ComponentAdapterParent } from "./component-adapter-parent";


/**
 * This class handle properties of light
 */
export class ComponentAdaperLight extends ComponentAdapterParent implements IComponentLoader {
    private _turnOnOffCommand: AddressDetails = null;
    private _turnOnOffState: AddressDetails = null;

    /**
     * Get the turn on/off command
     */
    get TurnOnOffCommand(): AddressDetails {
        return this._turnOnOffCommand;
    }

    /**
     * Get the turn on/off state
     */
    get TurnOnOffState(): AddressDetails {
        return this._turnOnOffState;
    }

    constructor() {
        super();
    }

    public fillProperty(listSmartComponentSkills: Array<SmartComponentPropertyDetails>): void {
        this._name = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.LIGHT_NAME)?.value || "";
        this._turnOnOffCommand = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.LIGHT_COMMAND)?.address || null;
        this._turnOnOffState = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.LIGHT_STATE)?.address || null;

        this.fillMissingProperty();
        this.fillAddressState();
    }

    public fillMissingProperty(): void {
        //If the state is not set, set the state to the command
        if (this._turnOnOffState === null && this._turnOnOffCommand !== null) {
            this._turnOnOffState = this._turnOnOffCommand;
        }
    }

    public fillAddressState(): void {
        if (this._turnOnOffState) {
            this._listSubscribeAddress.push(this._turnOnOffState);
        }
    }
}